export default __webpack_public_path__ + "static/media/francois-hoang-xxZCfAnMUrM-unsplash-small.836b69ec.jpg";